"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayUtil = void 0;
var ArrayUtil = (function () {
    function ArrayUtil() {
    }
    ArrayUtil.max = function (arr) {
        return Math.max.apply(Math, arr);
    };
    ArrayUtil.isEmpty = function (arr) {
        return arr.length === 0;
    };
    ArrayUtil.random = function (arr) {
        return arr[Math.floor(Math.random() * arr.length)];
    };
    ArrayUtil.first = function (arr) {
        if (ArrayUtil.isEmpty(arr)) {
            throw Error('Array is empty');
        }
        return arr[0];
    };
    ArrayUtil.last = function (arr) {
        if (ArrayUtil.isEmpty(arr)) {
            throw Error('Array is empty');
        }
        return arr[arr.length - 1];
    };
    return ArrayUtil;
}());
exports.ArrayUtil = ArrayUtil;
//# sourceMappingURL=ArrayUtil.js.map